module.exports = __webpack_public_path__ + "static/wall-logo-2efb754a395815db4e892ba005c6a506.png";